/**
 * Money is an integer number of cents, as in the POS. Prices arrive as text in US
 * dollars ("$1,313.00") and leave as text in Singapore dollars; nothing in between is a
 * floating point amount.
 */
/** "$1,313.00" or "1313" to cents. Empty, "-" or anything unreadable is null, not zero. */
export function parseDollars(text) {
    if (text == null)
        return null;
    const cleaned = text.replace(/[$,\s]/g, "").replace(/^US/i, "");
    if (!/^\d+(\.\d{1,2})?$/.test(cleaned))
        return null;
    const [whole = "0", fraction = ""] = cleaned.split(".");
    return Number(whole) * 100 + Number((fraction + "00").slice(0, 2));
}
/**
 * Cents in one currency to cents in another at a rate given as a decimal string, so the
 * rate shown on screen is exactly the rate used. Rounded half away from zero.
 */
export function convert(cents, rate) {
    if (!/^\d+(\.\d+)?$/.test(rate))
        throw new Error(`not a rate: ${rate}`);
    const [whole = "0", fraction = ""] = rate.split(".");
    const scale = 10n ** BigInt(fraction.length);
    const scaled = BigInt(whole) * scale + BigInt(fraction || "0");
    const product = BigInt(cents) * scaled;
    const rounded = (product * 2n + scale) / (2n * scale);
    return Number(rounded);
}
export function formatCents(cents, symbol = "S$") {
    const sign = cents < 0 ? "-" : "";
    const abs = Math.abs(cents);
    const whole = Math.floor(abs / 100).toLocaleString("en-US");
    return `${sign}${symbol}${whole}.${String(abs % 100).padStart(2, "0")}`;
}
//# sourceMappingURL=money.js.map